const initialState = {
  name: null,
  newCalendar: false,
  calendarId: '',
  permissions: [],
};

export default initialState;
